import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import BotApi from 'api/bot';
import NoRecords from 'components/bots/NoRecords';
import withContentLoader from 'components/ui/withContentLoader';
import BotCard from './BotCard';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const BotList = ({ data = [] }) => {
  const { t } = useTranslation();

  const query = useQuery();
  const sector = query.get('sector');

  const filtered_bots = sector ? data.filter(bot => (bot.sectors[0] || {}).id === sector) : data;

  if (!filtered_bots.length) {
    return <NoRecords />;
  }

  const bots = filtered_bots.map(bot => (
    <div key={bot.id} className="col-md-4 mb-4">
      <BotCard {...bot} />
    </div>
  ));

  return (
    <div>
      <h6>
        {bots.length} {t('bots.bots_found')}
      </h6>
      <div className="row mt-4">{bots}</div>
    </div>
  );
};

const fetchData = async () => BotApi.fetch();
export default withContentLoader(BotList, { name: 'bots', fetchData });
